import { render } from "./PlaylistSettings.vue?vue&type=template&id=7e5b7c5c"
import script from "./PlaylistSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaylistSettings.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Playlist/PlaylistSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e5b7c5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e5b7c5c', __exports__)) {
    api.reload('7e5b7c5c', __exports__)
  }
  
  module.hot.accept("./PlaylistSettings.vue?vue&type=template&id=7e5b7c5c", () => {
    api.rerender('7e5b7c5c', render)
  })

}


export default __exports__